import { useState } from "react";
import styles from './app.module.scss';
import { useLocation } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { HelmetProvider } from "react-helmet-async";
import Toast from "../Toast/Toast";
import MetaDecoration from "../MetaDecoration/MetaDecoration";
import RefreshToken from "../../containers/RefreshToken/RefreshTokenContainer";
import NavBar from '../../containers/NavBar/NavBarContainer';
import Footer from '../../containers/Footer/FooterContainer';
import Routes from "../../containers/RoutesContainer";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthModalProvider } from "../../context/AuthModalContext";
import GlobalAuthModals from "../GlobalAuthModals/GlobalAuthModals";
import ChatWidget from "../../containers/ChatWidget/ChatWidgetContainer";
import ChatFloatingButton from "../../containers/ChatWidget/ChatFloatingButtonContainer";

const App = () => {
	const location = useLocation();
	const [openDownloadModalTop, setOpenDownloadModalTop] = useState<boolean>(false);
	const helmetContext = {};

	return (
		<HelmetProvider context={helmetContext}>
			<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
				<AuthModalProvider>
					<SnackbarProvider content={(key, message) => <Toast id={key} content={message} />}>
						<RefreshToken />
						<GlobalAuthModals />
						<div className={styles.app}>
							{
								!location.pathname.match("/delete_account") && <NavBar openDownloadModalTop={openDownloadModalTop} />
							}
							<Routes />
						</div>
						{
							!location.pathname.match("/delete_account") && 
							!location.pathname.startsWith("/autos/") && 
							<Footer />
						}
						<ChatWidget />
						<ChatFloatingButton />
					</SnackbarProvider>
				</AuthModalProvider>
			</GoogleOAuthProvider>
		</HelmetProvider>
	);
}

export default App;
